module.exports = __webpack_public_path__ + "media/src/images/page01_sub_001_zu02-2c5e18eee39bbc81f8c2390f42c3aeff.png";